// NB! this file should be generated using `gradlew generateApi`

type ApiClient = {
    execute: (apiMethod: string, request: any) => Promise<any>
}

import {
  GetFrontBubbleData$Request, GetFrontBubbleData$Response,
  GetSingleData$Request, GetSingleData$Response,
  Echo$Request, Echo$Response,
  GetGraphData$Request, GetGraphData$Response,
} from "./api-types";

export class ApiService {
    public singleData: SingleDataOperations;
    public analysis: AnalysisOperations;

    constructor(private api: ApiClient) {
        this.singleData = new SingleDataOperations(this.api);
        this.analysis = new AnalysisOperations(this.api);
    }

}

export class SingleDataOperations {
  constructor(private api: ApiClient) {}

  getFrontBubbleData(): Promise<GetFrontBubbleData$Response> {
    return this.api.execute("getFrontBubbleData", {});
  }
  getSingleData(request: GetSingleData$Request): Promise<GetSingleData$Response> {
    return this.api.execute("getSingleData", request);
  }

}
export class AnalysisOperations {
  constructor(private api: ApiClient) {}

  echo(request: Echo$Request): Promise<Echo$Response> {
    return this.api.execute("echo", request);
  }
  getGraphData(request: GetGraphData$Request): Promise<GetGraphData$Response> {
    return this.api.execute("getGraphData", request);
  }

}



// WEBPACK FOOTER //
// ./src/api/generated/api.service.ts